<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(index)="data">
						{{ data.index + 1 + (currentPage - 1) * perPage }}
					</template>
					<template v-slot:cell(nome)="row">
						<span style="display: block">{{ row.item.nome }}</span>
						<span style="display: block">({{ row.item.createUser }})</span>
					</template>
					<template v-slot:cell(statoAttuale)="row">
						<b-container class="bv-example-row">
							<stati-colors :statoLabel="row.item.statoAttuale"></stati-colors>
						</b-container>
					</template>
					<template v-slot:cell(descrizionePriorita)="row">
						<b-container class="bv-example-row">
							<priorita-colors :prioritaLabel="row.item.descrizionePriorita"></priorita-colors>
						</b-container>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Modifica Dati Progetto" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
								<b-icon icon="pencil" variant="outline-secondary"></b-icon>
							</b-button>
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Dettagli" @click="onClickDetails(row.item, row.index, $event.target)" class="mr-1 no-text">
								<i class="fab fa-creative-commons-nd"></i>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import UtilityMixin from "../../utility/UtilityMixin";
import StatiColors from "../utility/StatiColors.vue";
import PrioritaColors from "../utility/PrioritaColors.vue";
export default {
	components: { StatiColors, PrioritaColors },
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/gestioneattivitaattivita",
			pathResourceFromAsset: "/gestioneattivitaattivita/assets",
			linkedit: "/gestioneattivita/attivita",
			attivitaFilter: {},
			btnAggiungi: false,
			items: [],
			fields: [
				{
					label: "#",
					key: "index",
					sortable: true,
					thStyle: "width: 3rem",
					visible: true,
				},
				{
					label: "Nome",
					key: "nome",
					sortable: true,
				},
				{
					label: "Attivita",
					key: "tipoAttivita",
					sortable: true,
				},
				{
					label: "Data Inizio",
					key: "dataOraInizio",
					thStyle: "width: 8rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY");
						} else {
							return "-----";
						}
					},
					sortable: true,
				},
				{
					label: "Data Fine",
					key: "dataOraFine",
					thStyle: "width: 8rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY");
						} else {
							return "-----";
						}
					},
					sortable: true,
				},
				{
					label: "Priorità",
					key: "descrizionePriorita",
					sortable: true,
					thStyle: "width: 10rem",
				},
				{
					label: "Stato",
					key: "statoAttuale",
					sortable: true,
					thStyle: "width: 11rem",
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	watch: {
		currentPage() {
			this.loadData();
		},
	},
	methods: {
		init(filtro) {
			let me = this;
			me.attivitaFilter = filtro;
			me.loadData();
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			me.attivitaFilter.page = me.currentPage;
			me.attivitaFilter.forPage = me.perPage;
			UtilityMixin.methods.loadDataResources(me.pathResource, me.attivitaFilter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
		onEdit(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/edit/" + item.id).catch((err) => {
				err;
			});
		},
		onClickDetails(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/dettaglio/" + item.id).catch((err) => {
				err;
			});
		},
		loadFromAsset(filter) {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourceFromAsset, filter, me.loadFromAssetSuccess, me.loadFromAssetError);
		},
		loadFromAssetSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.$emit("afterLoadData");
		},
		loadFromAssetError() {},
	},
};
</script>

<style></style>
